module.exports = __webpack_public_path__ + "img/chat_a.1c633cc2.png";